import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { ContextMenu } from "primereact/contextmenu";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import { classNames } from "primereact/utils";
import { useDispatch, useSelector } from "react-redux";
import AddMDDriver from "../masterDataDriver/AddMDDriver";
import { _getMDDriverList, _removeUser } from "../../../Services/masterDataServices";
import EditMDDriver from "../masterDataDriver/EditMDDrivers";
import MasterDataAddButton from "../../../components/MasterData/MasterDataAddButton";
import { isAdmin } from "../../../CommomFiles/globalFunctions";
import {
  Button
} from "@postidigital/posti-components";
import { Dialog } from "primereact/dialog";
import { showToast } from "../../../CommomFiles/globalFunctions";
import { hideLoader, showLoader } from '../../../Store/Actions/commonAction';

const status = ["Active", "Inactive"];

const MDDriver = () => {
  const [bookings, setBookings] = useState(null);
  const [addDriverDialog, setAddDriverDialog] = useState(false);
  const [editProductsDialog, setEditProductsDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [product, setProduct] = useState();
  const [selectedDrivers, setSelectedDrivers] = useState(null);
  const cm = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userDetail = useSelector((state) => state.user.userDetail);
  const [cancelDelete, setcancelDelete] = useState(false);

  const menuModel = [
    {
      label: t("EDIT_DRIVER"),
      icon: "pi pi-fw pi-user-edit",
      command: () => confirmEditSelected(selectedProduct),
    },
  ];

  const isAdmin = () => {
    return (
      userDetail &&
      Object.keys(userDetail).length > 0 &&
      userDetail?.groups?.includes("SMS_Admin")
    );
  };

  useEffect(() => {
    getDriverDetails();
  }, []);

  const getDriverDetails = () => {
    dispatch(
      _getMDDriverList(
        { orgId:"o1" },
        (res) => {
          setBookings(res.data);
        },
        (err) => {
          console.log(err);
        }
      )
    );
  };

  const confirmEditSelected = (product) => {
    setProduct(product);
    setEditProductsDialog(true);
  };

  const updateBookingList = (data) => {
    const index = bookings.findIndex(
      (item) => item.driverId === data.driverId
    );
    const tempArray = [...bookings];
    tempArray.splice(index, 1, data);
    setBookings(tempArray);
  };
  
  const addBookingList = (data) => {
    const tempArray = [...bookings];
    tempArray.splice(0, 0, data);
    setBookings(tempArray);
  };

  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={status}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        placeholder={t("SELECT_A_STATUS")}
        className="p-column-filter"
        showClear
      />
    );
  };

  const statusBodyTemplate = (rowData) => {
    if (rowData.status === "ACTIVE") {
      rowData.status = "Active";
    } else if (rowData.status === "INACTIVE") {
      rowData.status = "Inactive";
    }
    const statusClassName = classNames({
      in_active: rowData.status === "Inactive",
      active: rowData.status === "Active",
    });
    return <div  className={statusClassName}>{rowData.status}</div>;
  };

  const removeCarrier=()=>{
    setcancelDelete(true);
  }

  const confirmDelete = () => {
    const selectedDriverIds = [];
    selectedDrivers.map(driver=>{
      selectedDriverIds.push(driver.driverId)
    })
    const params = { cognitoId:selectedDriverIds,userType:"driver", orgId: "o1" };
    dispatch(
       _removeUser(
        params,
        (res) => {
          dispatch(showLoader());
          setSelectedDrivers(null) ;
          selectedDrivers.length = 0;
          getDriverDetails();
          showToast(t("DRIVER_DELETE_SUCCESS"), "success");
          dispatch(hideLoader());
        },
        (err) => {
          console.log("Driver delete error", err);
          // showToast(t("DRIVER_DELETE_FAILURE"), "error");
        }
      )
     );
     setcancelDelete(false);
  };

  const closeAddDriverPopup =()=>{
    setAddDriverDialog(false);
    getDriverDetails();
  }

  return (
    <div>
      <ContextMenu
        model={menuModel}
        ref={cm}
        onHide={() => setSelectedProduct(null)}
      />
      <div className="box">
        <div>
          {
            isAdmin() && (selectedDrivers !== null && selectedDrivers.length > 0) ?
              <Button
                className="manageManagersButton"
                iconPosition="right"
                type="submit"
                size="sm"
                style={{ margin: "12px" }}
              onClick={removeCarrier}
              > {t("REMOVE_DRIVER")}</Button> : null
          }

        </div>
        <div>
          <DataTable
            value={bookings}
            stripedRows
            paginator={true}
            rows={5}
            contextMenuSelection={selectedProduct}
            onContextMenuSelectionChange={(e) => setSelectedProduct(e.value)}
            onContextMenu={(e) => isAdmin(userDetail)?cm.current.show(e.originalEvent):null}
            rowsPerPageOptions={[5, 10, 20]}
            rowHover
            responsiveLayout="scroll"
            selection={selectedDrivers}
            onSelectionChange={e => setSelectedDrivers(e.value)}
          >
            {
              isAdmin() ? <Column selectionMode="multiple" className="datatableHeaderWidth50" frozen={true} style={{ height: '35.5px', textAlign: 'center' }} />
                : null
            }
            <Column
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterPlaceholder={t("DRIVER_NAME")}
              field="driverName"
              header={t("DRIVER_NAME")}
            ></Column>
            <Column
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterPlaceholder={t("LICENSE_NUMBER")}
              field="drivingLicenseNo"
              header={t("LICENSE_NUMBER")}
            ></Column>
            <Column
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterPlaceholder={t("EMAIL")}
              field="driverEmail"
              header={t("EMAIL")}
            ></Column>
            <Column
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterPlaceholder={t("PHONE_NO")}
              field="driverPhNo"
              header={t("PHONE_NO")}
            ></Column>
            <Column
              filter
              showAddButton={false}
              showFilterOperator={false}
              showFilterMenuOptions={false}
              filterPlaceholder={t("STATUS")}
              field="status"
              body={statusBodyTemplate}
              header={t("STATUS")}
              filterElement={statusRowFilterTemplate}
            ></Column>
            <Column
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterPlaceholder={t("CARRIER_NAME")}
              field="carrierName"
              header={t("CARRIER_NAME")}
            ></Column>
          </DataTable>
        </div>
        
        <MasterDataAddButton
          title={"ADD_NEW_DRIVER"}
          onClick={(e) => setAddDriverDialog(true)}
        />
        
      </div>
      {editProductsDialog && (
        <EditMDDriver
          close={() => setEditProductsDialog(false)}
          booking={product}
          updateList={(data) => updateBookingList(data)}
        />
      )}
      {addDriverDialog && (
        <AddMDDriver
          close={() => closeAddDriverPopup()}
          updateList={(data) => addBookingList(data)}
        />
      )}
      <Dialog
          visible={cancelDelete}
          style={{ width: "450px", height: "215px" }}
          header={t("CONFIRM")}
          onHide={() => setcancelDelete(false)}
        >
          <div>
            <span style={{ color: "red", fontSize: "18px" }}>
              {t("DELETE_DRIVER")}
            </span>
            <div className="delayAndCancel">
              <div>
                <Button
                  onClick={() => confirmDelete()}
                  style={{
                    color: "#fff",
                    fontSize: "18px"
                  }}
                >
                  {t("YES")}
                </Button>
                <Button
                  onClick={() => setcancelDelete(false)}
                  style={{
                    color: "#fff",
                    fontSize: "18px",
                    marginLeft: "120px",
                    marginTop: "-62px"
                  }}
                >
                  {t("NO")}
                </Button>
              </div>
            </div>
          </div>
        </Dialog>
    </div>
  );
};

export default MDDriver;
